import AxiosInterceptor from 'api/interceptor';

const tag = new AxiosInterceptor();

export default {
  get() {
    return tag.get('/p_tag');
  },
  delete(id) {
    return tag.delete('/p_tag/' + id);
  },
  create(inputs) {
    return tag.post('/p_tag', {
      'name': inputs.name
    });
  }
};